import { createActions, createReducer } from 'reduxsauce'

import TipoConvenioService from '../servicos/TipoConvenioService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaTipoConvenioInicio: [],
    buscaTipoConvenioSucesso: ['tipoConvenio'],
    buscaTipoConvenioErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaTipoConvenio = () => {
    return dispatch => {
        dispatch(Creators.buscaTipoConvenioInicio())
        let serv = new TipoConvenioService()
        return serv
            .getTipoConvenio()
            .then(response => dispatch(Creators.buscaTipoConvenioSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaTipoConvenioErro(error)))
    }
}

const buscaTipoConvenioInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaTipoConvenioErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaTipoConvenioSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.tipoConvenio, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_TIPO_CONVENIO_INICIO]: buscaTipoConvenioInicio,
    [Types.BUSCA_TIPO_CONVENIO_ERRO]: buscaTipoConvenioErro,
    [Types.BUSCA_TIPO_CONVENIO_SUCESSO]: buscaTipoConvenioSucesso,
})
